import { Component, Input, OnInit } from '@angular/core';
import * as L from 'leaflet';


@Component({
  selector: 'app-geochart',
  templateUrl: './geochart.component.html',
  styleUrls: ['./geochart.component.scss']
})
export class GeochartComponent implements OnInit {

  _data: any;
  screenWidth: number;
  map: any;

  @Input() set data(data: any) {
    this._data = data;
    this.buildMap();
  }

  ngOnInit() {
    this.screenWidth = window.innerWidth;
    this.buildMap();
  }

  buildMap() {
    if (this.map) {
      this.map.remove();
    }
    const corner1 = L.latLng(80, -180);
    const corner2 = L.latLng(-70, 180);
    let fixedZoom: number;
    if (this.screenWidth >= 500) {
      fixedZoom = 1;
    } else {
      if (this.screenWidth >= 420) {
        fixedZoom = 0.75
      } else {
        if (this.screenWidth >= 350) {
          fixedZoom = 0.5;
        } else {
          fixedZoom = 0.25;
        }
      }
    }
    const mapOptions = {
      dragging: false,
      zoomControl: false,
      minZoom: fixedZoom,
      maxZoom: fixedZoom,
      maxBounds: L.latLngBounds(corner1, corner2),
      maxBoundsViscosity: 1,
      zoomSnap: 0.25
    };
    const map = L.map('map', mapOptions).setView([0, 0], fixedZoom);
    this.map = map;
    L.tileLayer('http://a.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);
    for (const country of this._data) {
      const markerOptions = {
        radius: 5 + 15 * country[1] / 100,
        stroke: true,
        weight: 1,
        color: '#fff',
        fillOpacity: 1,
        fillColor: '#34D1B0'
      };
      const marker = L.circleMarker([country[2].latitude, country[2].longitude], markerOptions).addTo(map);
      marker.bindTooltip('<div>' + country[0] + '<br>' + country[1].toFixed(2) + '%</div>', { direction: 'top', className: 'leaflet-tooltip' });
    }
  }
}
